import { ensureDate, formatShortDateOnly } from "../../other/dateTime/format";
import { Sanitize } from "../../other/sanitize/Sanitize";
import { useTheme } from "@emotion/react";
import { useInternalMediaLink } from "./useInternalMediaLink";
import { locationPrepend } from "../../other/devServer/locationPrepend";
import { internalMediaPrimaryButtonClass } from "./internalMediaActionButton";

type InternalMediaDto =
    RedDeer.InternalMedia.Client.UI.Contracts.Dtos.InternalMediaDto;

interface PropType {
    item: InternalMediaDto;
}

export function InternalMediaCarouselItem({ item }: PropType) {
    const theme = useTheme();
    const isDark = theme.name === "dark";
    const { href, onClick, target } = useInternalMediaLink(item.id);

    return (
        <div className="flex h-full flex-col justify-between">
            <div>
                <div
                    className={`mb-4 text-4xl font-bold ${isDark ? "text-white" : "text-slate-900"}`}
                >
                    {item.title}
                </div>
                <div className="mb-4 flex items-center gap-3">
                    <span
                        className={`text-xs ${isDark ? "text-slate-400" : "text-slate-500"}`}
                    >
                        {formatShortDateOnly(
                            ensureDate(item.publishedDateTime)
                        )}
                    </span>
                </div>

                {item.thumbnailImage && (
                    <img
                        src={`${locationPrepend()}/InternalMedia/Resource/${item.thumbnailImage}`}
                        alt={item.title}
                        className="mb-4 h-48 w-full rounded-lg object-cover"
                    />
                )}
                <div
                    className={`text-lg ${isDark ? "text-slate-300" : "text-slate-600"} mb-4 line-clamp-3 max-h-36 min-h-36 max-w-4xl overflow-auto`}
                >
                    <Sanitize content={item.previewDescription ?? ""} />
                </div>
            </div>
            {item.id && (
                <a
                    href={href}
                    onClick={onClick}
                    target={target}
                    className={internalMediaPrimaryButtonClass}
                >
                    Read Full Article
                </a>
            )}
        </div>
    );
}
